import React from 'react';
import moment from 'moment';
import Formsy from 'formsy-react';
import Modal from '../shared/Modal';
import FormRadio from '../form/Radio';
import Select from '../form/Select';
import FormsySimpleInput from '../form/FormsySimpleInput';
import DatePickerMulti from '../form/DatePickerMulti';
import { menuAPI } from '../../InterfaceAPI/menuAPI';
import {
  getHourOptionsWithBuffers,
  genHourOption,
} from '../../helpers/hourOptions';
import withSplashMessage from '../splashMessage/withSplashMessage';
import {
  SERVICE_TYPES,
  OCCASION_STATUS_LABELS,
  WEEKLY_STATUS_LABELS,
} from '../../const';
import { holidaysOnDate } from '../../helpers/holidays';
import zipToDistrict from '../../helpers/zipToDistrict';
import { maskServiceDate } from '../../masks';
import { isOccasion as isOccasionService } from '../../helpers/serviceUtil';

class ServiceEditDetailsModal extends React.Component {
  static service = {
    name: '',
    date: new Date(),
    end_time: '',
    start_time: '',
    portion_size: '',
    guest_number: '',
    occasion_type: '',
    additional_dates: [],
  };

  state = {
    service: ServiceEditDetailsModal.service,
    startHourOptions: [],
    endHourOptions: [],
    holiday: '',
  };

  portionOptions = [
    { value: 'small', label: 'Small (1-2 mouths)' },
    { value: 'medium', label: 'Medium (3-4 mouths)' },
    { value: 'large', label: 'Large (5-6 mouths)' },
  ];

  extendedMenuOptions = [
    { value: false, label: 'Regular' },
    { value: true, label: 'Extended' },
  ];

  cocktailOptions = [
    { value: false, label: 'No Cocktails' },
    { value: true, label: 'Cocktails' },
  ];

  occasionStatusOptions = Object.entries(OCCASION_STATUS_LABELS).map(
    ([key, val]) => ({ value: key, label: val })
  );

  weeklyStatusOptions = Object.entries(WEEKLY_STATUS_LABELS).map(
    ([key, val]) => ({ value: key, label: val })
  );

  locationOptions = [
    { value: 'new_york', label: 'New York' },
    { value: 'the_hamptons', label: 'The Hamptons' },
    { value: 'miami', label: 'Miami' },
    { value: 'aspen', label: 'Aspen' },
    { value: 'los_angeles', label: 'Los Angeles' },
  ];

  render() {
    const { isOpen, closeModal, hideServiceName } = this.props;
    const {
      id: service_id,
      name,
      date,
      additional_dates,
      end_time,
      start_time,
      dinner_start_time,
      service_type,
    } = this.state.service;
    const isOccasion = isOccasionService(this.state.service);

    let holiday = '';
    if (isOccasion && date) {
      holiday = holidaysOnDate(date);
    }

    let dateVal = date;
    let additionalDatesDisplay = [];
    const multiDates =
      Array.isArray(additional_dates) && additional_dates.length > 0;
    if (multiDates) {
      dateVal = [date].concat(additional_dates);
      additionalDatesDisplay = dateVal.map((date) => {
        const holiday = holidaysOnDate(date);
        return (
          maskServiceDate(date) +
          (holiday ? ` - Holiday Pricing: ${holiday}` : '')
        );
      });
    }

    return (
      <Modal isOpen={isOpen} onRequestClose={closeModal}>
        <div className="admin-wrapper">
          <Formsy className="form" onValidSubmit={this.handleSubmit}>
            <h2 className="h2 modal__heading">Edit Details</h2>
            <div
              className={'form__row ' + (!multiDates && 'form__row--spacer')}
            >
              {!hideServiceName && (
                <div className="form__row-item form__row-item--half">
                  <p className="simple-input__label">
                    {this.friendlyName()} Service Name
                  </p>
                  <FormsySimpleInput
                    type="text"
                    name="name"
                    placeholder=""
                    value={name || ''}
                    onChange={this.handleChange}
                    required
                  />
                </div>
              )}

              <div className="form__row-item form__row-item--half">
                <p className="simple-input__label">Date</p>
                <DatePickerMulti
                  name="date"
                  value={dateVal}
                  allowMulti={
                    !service_id &&
                    service_type === SERVICE_TYPES.CUSTOM_OCCASION
                  }
                  onChange={this.handleDateChange}
                />
                {multiDates ? (
                  <div className="selected-dates">
                    <p className="p p--bold selected-date">Selected Dates:</p>
                    {additionalDatesDisplay.map((date) => (
                      <p key={date} className="p p--em"> {date} </p>
                    ))}
                  </div>
                ) : (
                  <p className="p p--em holiday-pricing">
                    {holiday ? `Holiday Pricing: ${holiday}` : ''}
                  </p>
                )}
              </div>
            </div>

            {isOccasion ? (
              <div>
                <div className="form__row form__row--spacer">
                  <div className="form__row-item form__row-item--half">
                    <p className="simple-input__label">Appetizer Time</p>
                    {this.renderHourSelect('start_time', start_time)}
                  </div>
                  <div className="form__row-item form__row-item--half">
                    <p className="simple-input__label">Dinner Time</p>
                    {this.renderHourSelect(
                      'dinner_start_time',
                      dinner_start_time
                    )}
                  </div>
                </div>
                <div className="form__row form__row--spacer">
                  <div className="form__row-item form__row-item--half">
                    <p className="simple-input__label">End Time</p>
                    {this.renderHourSelect('end_time', end_time)}
                  </div>
                </div>
              </div>
            ) : (
              <div className="form__row form__row--spacer">
                <div className="form__row-item form__row-item--half">
                  <p className="simple-input__label">Start Time</p>
                  {this.renderHourSelect('start_time', start_time)}
                </div>
                <div className="form__row-item form__row-item--half">
                  <p className="simple-input__label">End Time</p>
                  {this.renderHourSelect('end_time', end_time)}
                </div>
              </div>
            )}
            {/* Commented out until location added to service model */}
            {/* {this.renderLocationRow()} */}
            {this.renderPortionRow()}

            <div className="form__row">
              <div className="form__row-item--half">
                <div
                  className="btn btn--hollow-red-bright btn--full-width"
                  onClick={closeModal}
                >
                  Cancel
                </div>
              </div>
              <div className="form__row-item--half">
                <input
                  type="submit"
                  className="btn btn--solid-blue btn--full-width"
                  value="Save"
                />
              </div>
            </div>
          </Formsy>
        </div>
      </Modal>
    );
  }

  renderLocationRow() {
    const { service } = this.state;

    return (
      <div className="form__row form__row--spacer">
        <div className="form__row-item form__row-item--full">
          <p className="simple-input__label">Location</p>
          <FormRadio
            className="radio--blue radio--large radio--full-width"
            name="location"
            placeholder=""
            options={this.locationOptions}
            value={service.location || ''}
            onChange={this.handleChange}
          />
        </div>
      </div>
    );
  }

  renderPortionRow() {
    const { service } = this.state;

    return service.service_type && isOccasionService(service) ? (
      // occasion & marketing occasion
      <div>
        <div className="form__row form__row--spacer">
          <div className="form__row-item form__row-item--half">
            <p className="simple-input__label">Type of Service</p>
            <FormsySimpleInput
              type="text"
              name="occasion_type"
              placeholder=""
              value={service.occasion_type || ''}
              onChange={this.handleChange}
            />
          </div>
          <div className="form__row-item form__row-item--half">
            <p className="simple-input__label">Number of Guests</p>
            <FormsySimpleInput
              type="number"
              name="guest_number"
              placeholder=""
              value={service.guest_number || ''}
              onChange={this.handleChange}
              required
            />
          </div>
        </div>
        <div className="form__row form__row--spacer">
          <div className="form__row-item form__row-item--full">
            <p className="simple-input__label">Zip Code</p>
            <FormsySimpleInput
              type="text"
              name="occasion_zip_code"
              placeholder=""
              value={service.occasion_zip_code || ''}
              onChange={this.handleChange}
              required
            />
            <p className="p p--em holiday-pricing">
              {zipToDistrict(service.occasion_zip_code) || ''}
            </p>
          </div>
        </div>
        <div className="form__row form__row--spacer">
          <div className="form__row-item form__row-item--full">
            <p className="simple-input__label">Service Status:</p>
            <FormRadio
              className="radio--blue radio--large radio--full-width"
              name="status"
              placeholder=""
              options={this.occasionStatusOptions}
              value={service.status || ''}
              onChange={this.handleChange}
              required
            />
          </div>
        </div>
        <div className="form__row form__row--spacer">
          <div className="form__row-item form__row-item--full">
            <p className="simple-input__label">Menu:</p>
            <FormRadio
              className="radio--blue radio--large radio--full-width"
              name="uses_extended_menu"
              placeholder=""
              options={this.extendedMenuOptions}
              value={service.uses_extended_menu}
              onChange={this.handleToggle}
              required
            />
          </div>
        </div>
        <div className="form__row form__row--spacer">
          <div className="form__row-item form__row-item--full">
            <p className="simple-input__label">Cocktails:</p>
            <FormRadio
              className="radio--blue radio--large radio--full-width"
              name="includes_cocktails"
              placeholder=""
              options={this.cocktailOptions}
              value={service.includes_cocktails}
              onChange={this.handleToggle}
              required
            />
          </div>
        </div>
      </div>
    ) : (
      // weekly / custom_weekly
      <div>
        <div className="form__row form__row--spacer">
          <div className="form__row-item form__row-item--full">
            <p className="simple-input__label">Portion Size</p>
            {/*todo: allow FormRadio to accept custom label sizes*/}
            <FormRadio
              className="radio--blue radio--large radio--full-width"
              name="portion_size"
              placeholder=""
              options={this.portionOptions}
              value={service.portion_size || ''}
              onChange={this.handleChange}
            />
          </div>
        </div>
        <div className="form__row form__row--spacer">
          <div className="form__row-item form__row-item--full">
            <p className="simple-input__label">Service Status:</p>
            <FormRadio
              className="radio--blue radio--large radio--full-width"
              name="status"
              placeholder=""
              options={this.weeklyStatusOptions}
              value={service.status || 'planned'}
              onChange={this.handleChange}
            />
          </div>
        </div>
      </div>
    );
  }

  renderHourSelect(name, value) {
    const hourOptions =
      name === 'end_time'
        ? this.state.endHourOptions
        : this.state.startHourOptions;
    return (
      <Select
        name={name}
        value={value}
        options={hourOptions}
        onChange={(value) => this.handleSelectChange(name, value)}
        required
      />
    );
  }

  friendlyName() {
    switch (this.state.service_type) {
      case 'weekly':
        return 'Weekly';
      case 'custom_weekly':
        return 'Weekly (Custom)';
      case 'occasion':
        return 'Occasion';
      case 'marketing_occasion':
        return 'Marketing Occasion';
      default:
        return '';
    }
  }

  handleToggle = (e) => {
    let { name, value } = e.target;
    value = value === 'true';
    const service = {
      ...this.state.service,
      [name]: value,
    };
    this.setState({ service });
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    const service = {
      ...this.state.service,
      [name]: value,
    };
    this.setState({ service });
  };

  handleDateChange = (date) => {
    let additional_dates = null;
    // hanlde multi select:
    if (Array.isArray(date)) {
      let dates = date;
      if (dates.length > 0) {
        date = dates[0];
        additional_dates = dates.slice(1);
      } else {
        // empty date array given
        this.setState({
          service: {
            ...this.state.service,
            date: null,
            additional_dates: [],
          },
        });
        return;
      }
    }
    // update start_time + end_time with the new date
    let start_time = '';
    if (this.state.service.start_time) {
      const start = moment(this.state.service.start_time.datetime)
        .year(date.getFullYear())
        .month(date.getMonth())
        .date(date.getDate());
      start_time = genHourOption(start);
    }

    let end_time = '';
    if (this.state.service.end_time) {
      const end = moment(this.state.service.end_time.datetime)
        .year(date.getFullYear())
        .month(date.getMonth())
        .date(date.getDate());
      end_time = genHourOption(end);
    }

    let dinner_start_time = undefined;
    if (isOccasionService(this.state.service)) {
      if (this.state.service.dinner_start_time) {
        const dinner_start = moment(
          this.state.service.dinner_start_time.datetime
        )
          .year(date.getFullYear())
          .month(date.getMonth())
          .date(date.getDate());
        dinner_start_time = genHourOption(dinner_start);
      }
    }

    // update service with new date
    const service = {
      ...this.state.service,
      date,
      start_time,
      dinner_start_time,
      end_time,
      additional_dates,
    };

    // update options with new date
    const { startHourOptions, endHourOptions } =
      ServiceEditDetailsModal.localizeHourOptions(
        date,
        isOccasionService(service)
      );
    this.setState({ service, startHourOptions, endHourOptions });
  };

  handleSelectChange = (name, value) => {
    const service = {
      ...this.state.service,
      [name]: value,
    };

    // also set the end_time if it's not already set
    if (name === 'start_time' && service.start_time && !service.end_time) {
      const end = moment(service.start_time.datetime).add(4, 'hours');
      service.end_time = genHourOption(end);
    }

    this.setState({ service });
  };

  handleSubmit = (e) => {
    const service = { ...this.state.service };
    service.start_time = ServiceEditDetailsModal.optionToString(
      service.start_time
    );
    service.end_time = ServiceEditDetailsModal.optionToString(service.end_time);
    if (isOccasionService(service)) {
      service.dinner_start_time = ServiceEditDetailsModal.optionToString(
        service.dinner_start_time
      );
    }

    if (service.service_type === 'weekly') {
      // weekly services- lookup and add the menu
      menuAPI
        .searchMenus({ search: { service_week: service.start_time } })
        .then(({ menus = [] }) => {
          service.menu = menus.length === 1 ? menus[0] : null;
          this.props.updateService(service);
        })
        .catch((err) => {
          this.props.addMessage({
            className: 'error',
            message: `Could not look up menu. ${err}`,
          });
          this.props.updateService(service);
        });
    } else this.props.updateService(service);
  };

  static localizeHourOptions(date, isOccasion = false) {
    const endBuffer = isOccasion ? 1 : 4;
    const interval = isOccasion ? 15 : 30;

    return {
      startHourOptions: getHourOptionsWithBuffers(
        moment(date),
        0,
        endBuffer,
        false,
        interval
      ),
      endHourOptions: getHourOptionsWithBuffers(
        moment(date),
        4,
        0,
        false,
        interval
      ),
    };
  }

  static optionToString(option) {
    return option.datetime.toISOString();
  }

  interpretService() {
    const nextService = { ...this.props.service };
    ['start_time', 'dinner_start_time', 'end_time'].forEach((key) =>
      this.formatTimesForSelect(nextService, key)
    );

    return { ...ServiceEditDetailsModal.service, ...nextService };
  }

  formatTimesForSelect(service, key) {
    // if string, convert to object
    if (typeof service[key] === 'string') {
      const momentStart = moment(service[key]);
      const time = genHourOption(momentStart);
      if (time.value !== service[key].value) service[key] = time;
    }
  }

  deriveState() {
    const { service_type } = this.props.service;
    const service = this.interpretService();
    service.service_type = service_type;
    const date =
      service && 'date' in service && service.date ? service.date : Date();
    const { startHourOptions, endHourOptions } =
      ServiceEditDetailsModal.localizeHourOptions(
        date,
        isOccasionService(service)
      );
    return {
      service,
      startHourOptions,
      endHourOptions,
    };
  }

  componentDidMount() {
    // initialize state from props
    const state = this.deriveState();
    this.setState(state);
  }

  componentDidUpdate(prevProps) {
    // update state from props
    if (this.props.service !== prevProps.service) {
      const state = this.deriveState();
      this.setState(state);
    }
  }
}
export default withSplashMessage(ServiceEditDetailsModal);



// WEBPACK FOOTER //
// ./src/components/service/ServiceEditDetailsModal.js